import TextLato from '@photosi/rn-components/text/text-lato/TextLato';
import { ButtonTextChildProps } from './ButtonTextChild.types';
import { mergeStyles } from 'src/_shared/utils/mergeStyles';
import { TBaseButtonChildrenProps } from '../../base-button/BaseButton.types';

export const ButtonTextChild = ({
  text,
  textStyle,
  textDisabledStyle,
  textFocusStyle,
  textHoverStyle,
  textPressedStyle,
  textEllipsizeMode,
  textNumberOfLines,
  textTestID,
  disabled,
  focused,
  hovered,
  pressed,
}: ButtonTextChildProps & TBaseButtonChildrenProps) => {
  if (text) {
    let eventTextStyle;
    if (disabled) {
      eventTextStyle = textDisabledStyle;
    } else if (pressed) {
      eventTextStyle = textPressedStyle;
    } else if (hovered) {
      eventTextStyle = textHoverStyle;
    } else if (focused) {
      eventTextStyle = textFocusStyle;
    }
    return (
      <TextLato
        testID={textTestID}
        style={mergeStyles(textStyle, eventTextStyle)}
        ellipsizeMode={textEllipsizeMode}
        numberOfLines={textNumberOfLines}
      >
        {text}
      </TextLato>
    );
  } else {
    return null;
  }
};
